<div class="old-browse-container">
  <div class="row">
    <div class="col-12 text-center">
      <h4 class="page-old-browser-used">{{ $t('error.USER_CANNOT_USE_IE') }}</h4>
    </div>
  </div>
</div>